import { AuthGuard } from '@guards/auth.guard';
import { LayoutComponent } from '@layout/layout.component';
import { PreloginLayoutComponent } from '@layout/prelogin-layout/prelogin-layout.component';
import { PathMatch } from '@model/common-type';
import { Routes } from '@angular/router';
import { RefreshTokenResolver } from '@shared/resolvers/refresh-token.resolver';

export const routes: Routes = [
    {
        path: '',
        component: LayoutComponent,
        resolve: [RefreshTokenResolver],
        canActivate: [AuthGuard],
        children: [
            { path: '', redirectTo: 'm', pathMatch: 'full' as PathMatch },
            {
                path: 'm',
                loadChildren: () => import('@modules/mailbox/mailbox.module').then(m => m.MailboxModule)
            },
            {
                path: 'a',
                loadChildren: () => import('@modules/contact/contact.module').then(m => m.ContactModule)
            },
            {
                path: 'settings',
                loadChildren: () => import('@modules/settings/settings.module').then(m => m.SettingsModule)
            },
            {
                path: 'c',
                loadChildren: () => import('@modules/calendar/calendar.module').then(m => m.CalendarModule)
            }
        ]
    },
    {
        path: 'p',
        loadChildren: () => import('@modules/popout/popout.module').then(m => m.PopoutModule)
    },
    {
        path: '', component: PreloginLayoutComponent, children: [
            { path: '', redirectTo: 'login', pathMatch: 'full' as PathMatch },
            {
                path: 'login',
                loadChildren: () => import('@modules/login/login.module').then(m => m.LoginModule)
            },
            {
                path: 'change-password',
                loadChildren: () => import('@modules/change-password/change-password.module').then(m => m.ChangePasswordModule)
            }
        ]
    },
    { // Alarm bu sayfada çıkmasın diye buraya koyduk
        path: 'print',
        loadChildren: () => import('@modules/print/print.module').then(m => m.PrintModule)
    },
    {
        path: 'home',
        loadChildren: () => import('@modules/home/home.module').then(m => m.HomeModule)
    },
    {
        path: 'sso_callback',
        loadChildren: () => import('@modules/sso-callback/sso-callback.module').then(m => m.SsoCallbackModule)
    },
    {
        path: 'client-login',
        loadChildren: () => import('@modules/client-login/client-login.module').then(m => m.ClientLoginModule)
    },
    {
        path: 'logout',
        loadChildren: () => import('@modules/logout/logout.module').then(m => m.LogoutModule)
    },
    { path: '**', redirectTo: 'login' }
];
